import {cn} from '@/lib/utils';

interface Props {
  className?: string;
}

export default function Bed({className}: Props) {
  return (
    <svg
      className={cn('fill-current text-gray-500', className)}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="20"
      viewBox="0 0 24 20">
      <path
        fill="currentColor"
        fillRule="nonzero"
        d="M11 5.998a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm4 0a1 1 0 1 1 0-2 1 1 0 0 1 0 2zM13 9a1 1 0 1 1 0-2 1 1 0 0 1 0 2zM9 9a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm8 0a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm7 2v2h-2v1c0 1.89-1.235 3.584-3 4l1 2h-2l-1-2H7l-1 2H4l1-2c-1.765-.416-3-2.11-3-4v-1H0v-2h20V3c0-.551-.449-1-1-1h-5v1h-2V0h7c1.654 0 3 1.346 3 3v8h2zm-4 3v-1H4v1c0 1.102.897 2 2 2h12c1.103 0 2-.898 2-2z"
      />
    </svg>
  );
}
